import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateProjectComponent } from './create-project.component';
import { DatePickerModule } from '../date-picker/date-picker.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OpsNumberDirective } from '@ops/components';
import { TranslateModule } from '@ngx-translate/core';
import { OpsCustomCurrencyModalComponent } from '@ops/storybook';
import { NumericInputComponent } from '../numeric-input/numeric-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    DatePickerModule,
    OpsNumberDirective,
    TranslateModule,
    OpsCustomCurrencyModalComponent,
    NumericInputComponent,
  ],
  exports: [CreateProjectComponent],
  declarations: [CreateProjectComponent],
})
export class CreateProjectModule {}
